import EbaySyncTaskDetail from "./EbaySyncTaskDetail";

function EbaySyncDetailModal({ syncRunId, onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15, 23, 42, 0.5)",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "2rem 1rem",
        zIndex: 1000,
        overflowY: "auto",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#ededed",
          borderRadius: "12px",
          maxWidth: "1100px",
          width: "100%",
          maxHeight: "calc(100vh - 4rem)",
          overflowY: "auto",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <EbaySyncTaskDetail syncRunId={syncRunId} onClose={onClose} isModal />
      </div>
    </div>
  );
}

export default EbaySyncDetailModal;
